import { SCOPE as PARENT_SCOPE } from '../types';

export const SCOPE = `${PARENT_SCOPE}.config`;

export const INIT = `${SCOPE}/INIT`;
export const GET_CONFIG = `${SCOPE}/GET_CONFIG`;
